export const CHAT_TYPE = {
  QUESTION: 0, // 提问
  ANSWER: 1, // 回答
  OTHER: 2
};
// 消息状态
export const ANSWER_STATUS = {
  PENDING: 0, // 思考中
  DONE: 1, // 已作答
  MISS: 2, // 未命中
  FAIL: 3, // 未知异常
  INTENT_ERR: 4, // 意图识别失败
  REJECT: 5 // 已移除
};
// 消息类型 小于0的为前端自定义，非入库
export const MSG_TYPE = {
  END: -4, // 没有更多了
  STOP: -2, // 停止回答
  WELCOME: -1, // 欢迎语
  TEXT: 0, // 内容
  IMAGE: 1, // 传输结束
  ERROR: 2, // 失败
  INSTRUCT: 3, // 指令数据
  INSTRUCT_FILL: 4, // 指令补全参数
  INSTRUCT_CONFIRM: 5, // 指令二次确认框
  EXAMPLE: 6, // 调用示例
  PROMPT: 7, // ai提示语 已经去掉了
  GUESS: 8 // 意图识别
};

export const ASK_TYPE = {
  KNOWLEDGE: 0, // 知识问答
  INSTRUCT: 1, // 指令
  INTERNET: 2 // 互联网问问
};
